var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { injectIntl } from "@irati/utils/lang";
import { WhoRewardedRewardTypes, WhoRewardedVisibilityTypes, WhoRewardedTypes } from "@irati/reward/enums/WhoRewardedTypes";
import { getRewardDescription, getRewardText, getUserText } from "@irati/reward/utils/whoRewarded/textHelpers";
import { getVisibilityType, getRewardType, getUserType } from "@irati/reward/utils/whoRewarded/typeHelpers";
import { DisplayIconWrapper, DescriptionWrapper } from "./styled";
import DisplayIcon from "./DisplayIcon";
import DisplayDescription from "./DisplayDescription";
var WhoRewarded = /** @class */ (function (_super) {
    __extends(WhoRewarded, _super);
    function WhoRewarded() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WhoRewarded.prototype.render = function () {
        var _a = this.props, reward = _a.reward, rewardOrder = _a.rewardOrder, intl = _a.intl;
        var formatMessage = intl.formatMessage;
        var visibilityType = getVisibilityType();
        var userType = getUserType(rewardOrder);
        var rewardType = getRewardType(reward, rewardOrder);
        var isHidden = visibilityType === WhoRewardedVisibilityTypes.HIDDEN;
        var isViewer = userType === WhoRewardedTypes.VIEWER;
        var isLimited = visibilityType === WhoRewardedVisibilityTypes.LIMITED;
        if (rewardType === WhoRewardedRewardTypes.NO_REWARD)
            return null;
        if (isHidden && isViewer)
            return null;
        var rewardDescription = getRewardDescription(reward, rewardOrder, rewardType);
        var rewardText = getRewardText(rewardType, formatMessage);
        var userText = getUserText(formatMessage, userType, rewardOrder.createdBy);
        return (React.createElement(React.Fragment, null,
            React.createElement(DisplayIconWrapper, null,
                React.createElement(DisplayIcon, { rewardType: rewardType })),
            React.createElement(DescriptionWrapper, null, isLimited && isViewer ? (rewardText) : (React.createElement(DisplayDescription, { costPerUnit: rewardDescription.costPerUnit, text: rewardDescription.text }))),
            React.createElement("span", null, " " + userText)));
    };
    return WhoRewarded;
}(PureComponent));
export default injectIntl(WhoRewarded);
